import { useCallback, useEffect, useState } from 'react'
// import { debounce } from "throttle-debounce"

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)
  const tellSize = () => {
    setIsMobile(window.innerWidth < 768)
  }
  const debounceTellSize = useCallback((150, tellSize), [])

  useEffect(() => {
    window.addEventListener('resize', debounceTellSize)
    return () => {
      window.removeEventListener('resize', debounceTellSize)
    }
  }, [])
  useEffect(debounceTellSize, [])
  return isMobile
}
